// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"640":"e6541336","828":"688d786e","851":"1275e26f"}[chunkId] + ".chunk.js";
};